/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import {
    bool,
    object, shape, string,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import index from 'mbp-logger';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import {  addonGroupsType } from '../../common/types';
import AddonV3List from './AddonV3List';
import AddonV3HeaderPanel from './AddonV3HeaderPanel';
import { resetWineData } from '../../../../../../../state/ducks/App/App-Actions';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import PDPAddonSkeleton from '../../../../GraphqlSkeletonComponents/PDPAddonSkeleton';
import useClickStreamCustomEventsTracking from '../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import AddonIcon from '../../GraphqlPDPSkus/AddonIcon';

const styles = (theme) => ({
    panelRoot: {
        boxShadow: 'none',
        backgroundColor: 'inherit',
        margin: '0px 0px 16px 0px !important',
        border: `1px solid ${theme.palette.strokeBorderColor || '#C4C4C4'}`,
        '& .Mui-focused': {
            background: 'transparent',
        },
        '@media screen and (min-width: 768px)': {
            maxWidth: 650,
        },
    },
    summaryRoot: {
        backgroundColor: 'inherit',
        minHeight: 37,
        padding: 0,
        fontSize: '18px',
        '&.Mui-expanded': {
            margin: 0,
            minHeight: 37,
        },
        '& .MuiExpansionPanelSummary-content': {
            margin: '0 10px',
        },
        '& .MuiExpansionPanelSummary-content.Mui-expanded': {
            borderBottom: `1px solid ${theme.palette.strokeBorderColor || '#C4C4C4'}`,
        },
    },
    detailsRoot: {
        padding: '16px',
        fontSize: '14px',
        overflow: 'auto',
        flexDirection: 'column',
    },
    container: {
        display: 'flex',
    },
    summaryContent: {
        margin: '0px !important',
    },
    label: {
        display: 'flex',
    },
    addonWrapper: {
        border: '0px',
        margin: '0px 0px 24px 0px !important',
        [theme.breakpoints.down('600')]: {
            paddingLeft: '16px',
        },
        '& .MuiCollapse-entered , $summaryRoot': {
            background: '#ffffff',
        },
        '& $detailsRoot': {
            padding: '0px',
        },
        '& $summaryRoot': {
            '& .MuiExpansionPanelSummary-content.Mui-expanded': {
                borderBottom: '0px',
            },
        },
        '& $label': {
            width: '100%',
        },
    },

});

const AddonV3 = ({
    classes,
    addonGroups,
    brand,
    isPdpRedesignEnabled,
    content,
}) => {
    const addonsPresentation = content?.entries?.[0]?.add_ons_presentation || {};
    const [contentActive, setContentActive] = useState();
    const [addOn, setAddOn] = useState(addonGroups?.[0]);
    const isDesktop = useMediaQuery('(min-width: 768px)');

    const dispatch = useDispatch();
    const handleChangePanel = (panel) => (event, newExpanded) => {
        setContentActive((newExpanded) ? panel : null);
        dispatch(trackEvent({
            eventCategory: 'Inline Addons',
            eventAction: newExpanded ? 'Expand' : 'Collapse',
            eventLabel: '',
        }));
    };

    const showAddons = (group) => {
        setAddOn(group);
        dispatch(trackEvent({
            eventCategory: 'Inline Addons',
            eventAction: 'Category Viewed',
            eventName: 'feature_interaction',
            feature_detail: group.name,
            feature_element: 'Category Viewed',
            feature_category: 'Inline Addons',
        }));
    };
    useEffect(() => {
        dispatch(resetWineData());
    }, []);
    let redesignStyle = '';
    if (isPdpRedesignEnabled) {
        redesignStyle = classes.addonWrapper;
    }

    return (
        <>
            {isPdpRedesignEnabled && isDesktop && <AddonIcon addonsPresentation={addonsPresentation} />}
            <ExpansionPanel classes={{ root: `${classes.panelRoot} ${redesignStyle}` }} square expanded={isPdpRedesignEnabled ? true : contentActive} onChange={handleChangePanel(index)}>
                <ExpansionPanelSummary classes={{ root: classes.summaryRoot, content: classes.summaryContent }}>
                    <Typography
                        component="div"
                        variant="h6"
                        className={classes.label}
                    >
                        <AddonV3HeaderPanel contentActive={contentActive} brand={brand} isPdpRedesignEnabled={isPdpRedesignEnabled} addOn={addOn} />
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails classes={{ root: classes.detailsRoot }}>
                    <div
                        className={classes.fullWidth}
                    >
                        <AddonV3List addonGroups={addonGroups} isPdpRedesignEnabled={isPdpRedesignEnabled} addOn={addOn} showAddons={showAddons} />
                    </div>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </>
    );
};
AddonV3.propTypes = {
    classes: object.isRequired,
    addonGroups: addonGroupsType.isRequired,
    brand: shape({
        domain: string,
    }).isRequired,
    isPdpRedesignEnabled: bool,
    content: object.isRequired,
};
AddonV3.defaultProps = {
    isPdpRedesignEnabled: false,
};
export default (withStyles(styles)(AddonV3));
